export default __webpack_public_path__ + "static/media/repost-hover-icon.8dfba30a.svg";